
import rp1015 from "./rp1015";
import rp1016 from "./rp1016";
import rp1017 from "./rp1017";
import rp1018 from "./rp1018";
import rp1036 from "./rp1036";
import rp1037 from "./rp1037";
import rp1038 from "./rp1038";
import rp1039 from "./rp1039";
import rp1040 from "./rp1040";
import rp1041 from "./rp1041";
import rp1042 from "./rp1042";
import rp1043 from "./rp1043";
import rp1044 from "./rp1044";
import rp1045 from "./rp1045";
import rp1046 from "./rp1046";
import rp1047 from "./rp1047";
import rp1048 from "./rp1048";
import rp1049 from "./rp1049";
import rp1050 from "./rp1050";
import rp1051 from "./rp1051";
import rp1052 from "./rp1052";
import rp1053 from "./rp1053";
import rp1054 from "./rp1054";
import rp1055 from "./rp1055";
import rp1056 from "./rp1056";
import rp1057 from "./rp1057";
import rp1058 from "./rp1058";
import rp1059 from "./rp1059";
import rp1060 from "./rp1060";
import rp1061 from "./rp1061";
import rp1062 from "./rp1062";
import rp1064 from "./rp1064";
import rp1065 from "./rp1065";
import rp1066 from "./rp1066";
import rp1067 from "./rp1067";
import rp1068 from "./rp1068";
import rp1069 from "./rp1069";
import rp1070 from "./rp1070";
import rp1071 from "./rp1071";
import rp1072 from "./rp1072";
import rp1078 from "./rp1078";
import rp1079 from "./rp1079";
import rp1080 from "./rp1080";
export default {
rp1017,
rp1016,
rp1015,
  rp1080,
rp1079,
rp1078,
rp1072,
rp1071,
rp1070,
rp1069,
rp1068,
rp1067,
rp1066,
rp1065,
rp1064,
rp1062,
rp1061,
rp1060,
rp1059,
rp1058,
rp1057,
rp1056,
rp1055,
rp1054,
rp1053,
rp1052,
rp1051,
rp1050,
rp1049,
rp1048,
rp1047,
rp1046,
rp1045,
rp1044,
rp1043,
rp1042,
rp1041,
rp1040,
rp1039,
rp1038,
rp1037,
rp1036,
rp1018,
};